import "./App.css";
import Doctors from "./Components/Doctors";
import { Route, Routes, useLocation } from "react-router-dom"; // Import useLocation hook
import { useState, useEffect } from "react";
import Docdetail from "./Components/Doctors/docdetail";
import Navbar from "./Navbar";
import About from "./Components/About";
import Departments from "./Components/Departments";
import Contact from "./Components/Contact";
import Home from "./Components/Home";
import Blogs from "./Components/Blogs";
import Signin from "./Components/Signin/signin";
import Login from "./Components/Login/login";
import PatientDash from "./Components/Patients/patientdash";
import Footer from "./Footer";
import Admin from "./Admin/Admin";
import AdminNavbar from "./Admin/Common/Navbar";
import AdminDoctorTable from "./Admin/Admin/Doctors/doctortable";
import AdminAppointmnetTable from "./Admin/Admin/Appointments/appointments";
import AdminPatientTable from "./Admin/Admin/Patients/patientstable";
import Blog from "./Components/Blogs/blog";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PageLoader from "./Components/pageloader";

function App() {
  const location = useLocation(); // Get the current location
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => setLoading(false), 1500); // simulate load
    return () => clearTimeout(timeout);
  }, [location]);

  // Define an array of paths where the Navbar should be hidden
  // const hiddenPaths = ['/signin' , '/patientdash' , '/admin/*/dashboard' , '/admin/*/doctors' , '/admin/*/patients' , '/admin/*/appointments'];
  // const hiddenAdminPaths = ['/signin' , '/' , '/about' , '/departments' , '/contact' , '/blogs' , '/patientdash' , '/doctors' , '/doctor/:id'];
  // const hiddenFooter = ['/signin' , '/admin/*/dashboard' , '/admin/*/doctors' , '/admin/*/patients' , '/admin/*/appointments'];

  // // Check if the current path is in the hiddenPaths array
  // const hideNavbar = hiddenPaths.includes(location.pathname);
  // const hideAdminNavbar = hiddenAdminPaths.includes(location.pathname);
  // const hideFooter = hiddenFooter.includes(location.pathname);

  // Define an array of paths where the Navbar should be hidden
  const hiddenPaths = [
    "/login",
    "/signin",
    "/admin/*/dashboard",
    "/admin/*/doctors",
    "/admin/*/patients",
    "/admin/*/appointments",
  ];
  const hiddenAdminPaths = [
    "/signin",
    "/login",
    "/patientdash",
    "/",
    "/about",
    "/departments",
    "/contact",
    "/blogs",
    "/doctors",
    /^\/doctors\/\d+$/,
    /^\/blogs\/\d+$/,
  ];
  const hiddenFooter = [
    "/login",
    "/signin",
    "/admin/*/dashboard",
    "/admin/*/doctors",
    "/admin/*/patients",
    "/admin/*/appointments",
  ];

  // Check if the current path is in the hiddenPaths array
  const hideNavbar = hiddenPaths.includes(location.pathname);
  const hideAdminNavbar = hiddenAdminPaths.some((path) => {
    if (typeof path === "string") {
      return path === location.pathname;
    } else if (path instanceof RegExp) {
      return path.test(location.pathname);
    }
  });
  const hideFooter = hiddenFooter.includes(location.pathname);
  return (
    <>
      {!hideAdminNavbar && <AdminNavbar />}
      {!hideNavbar && <Navbar />}{" "}
      {/* Render Navbar except for paths in hiddenPaths array */}
      
      <ToastContainer position="top-right" autoClose={2000} />
      {loading && <PageLoader />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/departments" element={<Departments />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:id" element={<Blog />} />
        <Route exact path="/doctors" element={<Doctors />} />
        <Route path="/doctors/:id" element={<Docdetail />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="/login" element={<Login />} />
        <Route path="/patientdash" element={<PatientDash />} />
      </Routes>
      {!hideFooter && <Footer />}
    </>
  );
}

export default App;
